export interface ParsedFormField {
  name: string;
  type: string;
  required: boolean;
  label: string;
}

export function parseFormFields(raw: string | undefined): ParsedFormField[] {
  if (!raw?.trim()) {
    return [];
  }
  try {
    const parsed = JSON.parse(raw) as unknown;
    if (!Array.isArray(parsed)) {
      return [];
    }
    return parsed
      .filter((entry): entry is ParsedFormField => {
        if (typeof entry !== 'object' || entry == null) {
          return false;
        }
        const field = entry as Record<string, unknown>;
        return (
          typeof field.name === 'string' &&
          typeof field.type === 'string' &&
          typeof field.label === 'string'
        );
      })
      .map((field) => ({
        name: field.name,
        type: field.type,
        required: Boolean(field.required),
        label: field.label,
      }));
  } catch {
    return [];
  }
}
